<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-document"></i>
          </div>
          <div>
            <h1 class="banner-title">THỐNG KÊ LỊCH SỬ GIAO DỊCH</h1>
            <p class="banner-subtitle">Giám sát và kiểm tra lịch sử biến động số dư, đồng bộ giao dịch và đối soát thanh toán học phí qua SePay.</p>
          </div>
        </div>
        <div class="banner-actions flex gap-2">
          <el-button type="success" class="gradient-btn green-btn" icon="el-icon-refresh" @click="syncTransactionHistory">
            Đồng bộ lịch sử
          </el-button>
          
          <el-dropdown @command="handleCommand" class="modern-dropdown-wrapper">
            <el-button type="warning" class="gradient-btn purple-btn">
              Tác vụ Excel <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" class="modern-dropdown-menu">
              <el-dropdown-item command="exportExcel" icon="el-icon-download">Xuất Excel dữ liệu chọn</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-files"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng số giao dịch</p>
          <h3 class="stat-value">{{ totalPage }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-bank"></i></div>
        <div class="stat-info">
          <p class="stat-label">Giao dịch trong ngày</p>
          <h3 class="stat-value">Tự động đối soát</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-connection"></i></div>
        <div class="stat-info">
          <p class="stat-label">Loại kết nối</p>
          <h3 class="stat-value">SePay API</h3>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="glass-card mb-4">
      <el-form :inline="true" :model="dataFilter" class="modern-filter-form">
        <el-form-item label="Khoảng thời gian">
          <el-date-picker
            v-model="times"
            :clearable="false"
            type="daterange"
            range-separator="-"
            start-placeholder="Bắt đầu"
            end-placeholder="Kết thúc"
            class="modern-date-picker"
            @change="findAllData(activeTabName)"
          />
        </el-form-item>

        <el-form-item label="Trường học">
          <el-select
            v-model="dataFilter.idSchool"
            filterable
            clearable
            placeholder="Tất cả các trường"
            class="modern-select school-select"
            @change="findAllData(activeTabName)"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :value="item.id"
              :label="`${item.id} - ${item.schoolName}`"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Loại giao dịch">
          <el-select
            v-model="dataFilter.transferType"
            filterable
            clearable
            placeholder="Tất cả loại"
            class="modern-select"
            @change="findAllData(activeTabName)"
          >
            <el-option
              v-for="item in transferTypeList"
              :key="item.id"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Số tài khoản">
          <el-input
            v-model="dataFilter.accountNumber"
            clearable
            placeholder="Nhập số tài khoản..."
            class="modern-input"
            prefix-icon="el-icon-search"
            @keyup.enter.native="findAllData(activeTabName)"
            @clear="findAllData(activeTabName)"
          />
        </el-form-item>

        <el-form-item label="Tên học sinh" v-if="activeTabName === 'school'">
          <el-input
            v-model="dataFilter.name"
            clearable
            placeholder="Nhập tên học sinh..."
            class="modern-input"
            prefix-icon="el-icon-user"
            @keyup.enter.native="findAllData(activeTabName)"
            @clear="findAllData(activeTabName)"
          />
        </el-form-item>

        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="findAllData(activeTabName)">Lọc giao dịch</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Main Tabs & Table Section -->
    <div class="glass-card table-container">
      <el-tabs type="card" v-model="activeTabName" @tab-click="handleClickTab" class="modern-tabs">
        <!-- Tab 1: Trong trường -->
        <el-tab-pane label="Trong trường học" name="school">
          <el-table
            ref="multipleTable"
            :data="dataTable"
            v-loading="loading.table"
            element-loading-text="Đang tải lịch sử giao dịch..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255,0.7)"
            class="modern-table"
            border
            highlight-current-row
            @selection-change="handleSelectionChange"
            :max-height="tableMaxHeight"
            :summary-method="getSummaries"
            show-summary
          >
            <el-table-column type="selection" width="55" align="center" fixed />
            <el-table-column type="index" :index="calculateStt" label="STT" width="55" align="center" fixed />

            <el-table-column label="Đại lý" min-width="180" prop="nameCompany" />
            
            <el-table-column label="Học sinh" width="160" fixed="left">
              <template slot-scope="{ row }">
                <el-tooltip placement="top">
                  <div slot="content">Mã HS: {{ row.kidCode }}<br>Lớp: {{ row.className }}</div>
                  <span class="student-name">{{ row.fullName }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="Trường học" min-width="200" prop="nameSchool" />

            <el-table-column label="ID giao dịch" min-width="150" prop="transactionId">
              <template slot-scope="{ row }">
                <code class="code-badge">{{ row.transactionId }}</code>
              </template>
            </el-table-column>

            <el-table-column label="Thời gian nhận GD" width="180" align="center">
              <template slot-scope="{ row }">
                <span class="date-time-text">{{ formatDate(row.transactionDate) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Số tài khoản nguồn" min-width="160" prop="accountNumber" align="center">
              <template slot-scope="{ row }">
                <span class="account-num-text">{{ row.accountNumber }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Tên chủ tài khoản" min-width="180" prop="nameAccount" />

            <el-table-column label="Ngân hàng" min-width="180" prop="nameBank" />

            <el-table-column label="ID Bank SePay" width="120" align="center" prop="idBankAccount" />
            <el-table-column label="ID VA" width="110" align="center" prop="idVa" />
            <el-table-column label="Số VA" width="120" align="center" prop="va" />
            <el-table-column label="Mã tham chiếu FT" width="160" align="center" prop="referenceNumber" />

            <el-table-column label="Nội dung ngân hàng báo" min-width="250" prop="transactionContent" />

            <el-table-column label="Mã thanh toán" width="140" align="center" prop="paymentCode">
              <template slot-scope="{ row }">
                <code class="code-badge success">{{ row.paymentCode }}</code>
              </template>
            </el-table-column>

            <el-table-column label="Loại giao dịch" width="120" align="center" prop="transferType">
              <template slot-scope="{ row }">
                <el-tag :type="row.transferType === 'credit' ? 'success' : 'danger'" size="medium" effect="dark">
                  {{ row.transferType === 'credit' ? 'Tiền vào' : 'Tiền ra' }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="Nội dung giao dịch" min-width="250" prop="contentOGV" />

            <el-table-column label="Số tiền giao dịch" width="160" align="right" prop="amount" fixed="right">
              <template slot-scope="{ row }">
                <span class="amount-text" :class="row.transferType === 'credit' ? 'credit' : 'debit'">
                  {{ row.amount | formatCurrency }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="Webhook" width="120" align="center" prop="receiveWebhook" fixed="right">
              <template slot-scope="{ row }">
                <el-tag :type="row.receiveWebhook ? 'success' : 'danger'" size="mini" effect="light">
                  {{ row.receiveWebhook ? 'Thành công' : 'Thất bại' }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- Tab 2: Ngoài trường -->
        <el-tab-pane label="Ngoài trường học" name="outSchool">
          <el-table
            ref="multipleTable"
            :data="dataTable"
            v-loading="loading.table"
            element-loading-text="Đang tải lịch sử giao dịch..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255,0.7)"
            class="modern-table"
            border
            highlight-current-row
            @selection-change="handleSelectionChange"
            :max-height="tableMaxHeight"
            :summary-method="getSummaries"
            show-summary
          >
            <el-table-column type="selection" width="55" align="center" fixed />
            <el-table-column type="index" :index="calculateStt" label="STT" width="55" align="center" fixed />

            <el-table-column label="Đại lý" min-width="180" prop="nameCompany" />
            
            <el-table-column label="Học sinh" width="160" fixed="left">
              <template slot-scope="{ row }">
                <el-tooltip placement="top">
                  <div slot="content">Mã HS: {{ row.kidCode }}<br>Lớp: {{ row.className }}</div>
                  <span class="student-name">{{ row.fullName }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="Trường học" min-width="200" prop="nameSchool" />

            <el-table-column label="ID giao dịch" min-width="150" prop="transactionId">
              <template slot-scope="{ row }">
                <code class="code-badge">{{ row.transactionId }}</code>
              </template>
            </el-table-column>

            <el-table-column label="Thời gian nhận GD" width="180" align="center">
              <template slot-scope="{ row }">
                <span class="date-time-text">{{ formatDate(row.transactionDate) }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Số tài khoản nguồn" min-width="160" prop="accountNumber" align="center">
              <template slot-scope="{ row }">
                <span class="account-num-text">{{ row.accountNumber }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Tên chủ tài khoản" min-width="180" prop="nameAccount" />

            <el-table-column label="Ngân hàng" min-width="180" prop="nameBank" />

            <el-table-column label="ID Bank SePay" width="120" align="center" prop="idBankAccount" />
            <el-table-column label="ID VA" width="110" align="center" prop="idVa" />
            <el-table-column label="Số VA" width="120" align="center" prop="va" />
            <el-table-column label="Mã tham chiếu FT" width="160" align="center" prop="referenceNumber" />

            <el-table-column label="Nội dung giao dịch ngân hàng" min-width="250" prop="transactionContent" />

            <el-table-column label="Mã thanh toán" width="140" align="center" prop="paymentCode">
              <template slot-scope="{ row }">
                <code class="code-badge success">{{ row.paymentCode }}</code>
              </template>
            </el-table-column>

            <el-table-column label="Loại giao dịch" width="120" align="center" prop="transferType">
              <template slot-scope="{ row }">
                <el-tag :type="row.transferType === 'credit' ? 'success' : 'danger'" size="medium" effect="dark">
                  {{ row.transferType === 'credit' ? 'Tiền vào' : 'Tiền ra' }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="Số tiền giao dịch" width="160" align="right" prop="amount" fixed="right">
              <template slot-scope="{ row }">
                <span class="amount-text" :class="row.transferType === 'credit' ? 'credit' : 'debit'">
                  {{ row.amount | formatCurrency }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="Webhook" width="120" align="center" prop="receiveWebhook" fixed="right">
              <template slot-scope="{ row }">
                <el-tag :type="row.receiveWebhook ? 'success' : 'danger'" size="mini" effect="light">
                  {{ row.receiveWebhook ? 'Thành công' : 'Thất bại' }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <!-- Pagination controls -->
      <div class="pagination-wrapper mt-3 flex justify-center">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page.sync="dataFilter.page"
          :page-sizes="listSizePage"
          :page-size="dataFilter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SystemConfigService from "@/services/AdminService/SystemConfigService";
import moment from "moment";
import sePayConnectionService from "@/services/SePayConnectionService";
import { exportExcelSepay } from "@/commonFuncion/ExportExcelSepay";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "BankTransactionStatistics",
  data() {
    return {
      dataTable: [],
      loading: {
        table: false
      },
      activeTabName: "school",
      schoolList: [],
      listData: [],
      dataFilter: {
        idSchool: "",
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        transferType: "",
        accountNumber: "",
        name: "",
        idClass: null,
        page: 1,
        limit: 50
      },
      times: "",
      listSizePage: [50, 100, 200, 300, 500, 1000, 2000, 3000, 5000],
      totalPage: 0,
      transferTypeList: [
        { id: 1, value: "credit", label: "Tiền vào" },
        { id: 2, value: "debit", label: "Tiền ra" }
      ],
      exportToExcelData: {
        titleFile: "THỐNG KÊ LỊCH SỬ GIAO DỊCH",
        columnWidths: [10, 30, 30, 30, 50, 30, 30, 30, 30, 30, 30, 30, 30, 30, 50, 30, 30, 30, 30],
        nameFile: "Thong_ke_lich_su_giao_dich_" + moment().format("DD-MM-YYYY_hh-mm-ss")
      }
    };
  },
  
  computed: {
    tableMaxHeight() {
      return this.$tableMaxHeight || 600;
    },
    
    completeExportToExcelData() {
      return {
        ...this.exportToExcelData,
        companyInfo: []
      };
    },
    
    titleFileWithDateRange() {
      const start = moment(this.dataFilter.startDate).format("DD-MM-YYYY");
      const end = moment(this.dataFilter.endDate).format("DD-MM-YYYY");
      return `THỐNG KÊ LỊCH SỬ GIAO DỊCH TỪ ${start} ĐẾN ${end}`;
    }
  },

  created() {
    this.findAllAppIconForSchool();
    const today = moment().format("YYYY-MM-DD");
    const tenDaysAgo = moment().subtract(10, "days").format("YYYY-MM-DD");

    this.dataFilter.startDate = tenDaysAgo;
    this.dataFilter.endDate = today;
    this.times = [this.dataFilter.startDate, this.dataFilter.endDate];
    this.findAllData(this.activeTabName);
  },

  methods: {
    exportExcelSepay,
    handleClickTab(tab) {
      this.dataFilter.limit = 50;
      this.dataFilter.page = 1;
      this.findAllData(tab.name);
    },

    formatDate(iso) {
      if (!iso) return "—";
      const d = new Date(iso);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())} - ${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    },

    async findAllAppIconForSchool() {
      try {
        const resp = await SystemConfigService.findSchoolConfig("", this.dataFilter.idSchool, true);
        if (this.dataFilter.idSchool === "") {
          this.schoolList = resp.data.data || [];
        }
      } catch (err) {
        console.error(err);
      }
    },

    async findAllData(value) {
      if (this.times && this.times.length === 2) {
        this.dataFilter.startDate = moment(this.times[0]).format("YYYY-MM-DD");
        this.dataFilter.endDate = moment(this.times[1]).format("YYYY-MM-DD");
      }
      this.loading.table = true;
      try {
        if (value === "school") {
          const res = await sePayConnectionService.getTransactionHistoryForAdmin(
            this.dataFilter.startDate,
            this.dataFilter.endDate,
            this.dataFilter.transferType,
            this.dataFilter.accountNumber,
            this.dataFilter.idSchool,
            this.dataFilter.name,
            this.dataFilter.idClass,
            this.dataFilter.limit,
            this.dataFilter.page
          );
          this.dataTable = res.data.data.responseList || [];
          this.totalPage = res.data.data.total || 0;
        } else {
          const res = await sePayConnectionService.getTransactionHistoryForAdminOutSchool(
            this.dataFilter.startDate,
            this.dataFilter.endDate,
            this.dataFilter.transferType,
            this.dataFilter.accountNumber,
            this.dataFilter.idSchool,
            this.dataFilter.limit,
            this.dataFilter.page
          );
          this.dataTable = res.data.data.responseList || [];
          this.totalPage = res.data.data.total || 0;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading.table = false;
      }
    },

    handleSelectionChange(value) {
      this.listData = value.map(item => {
        const copy = { ...item };
        copy.transferType = copy.transferType === "credit" ? "Tiền vào" : "Tiền ra";
        return copy;
      });
    },

    async handleExportExcel() {
      const title = this.titleFileWithDateRange;
      const fileName = this.exportToExcelData.nameFile;
      this.exportToExcelData.titleFile = title;
      this.exportToExcelData.nameFile = fileName;
      if (this.listData.length > 0) {
        this.$confirm("Bạn có chắc chắn muốn xuất file hiện tại?", "Thông báo!", {
          confirmButtonText: "Có",
          cancelButtonText: "Không",
          type: "warning"
        }).then(async () => {
          await this.exportExcelSepay(this.completeExportToExcelData, this.listData, "admin").then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Xuất file thành công");
          });
        });
      } else {
        NotifyMessage.leftCornerNotificationError("Không có dữ liệu được chọn!");
      }
    },

    handleCommand(command) {
      if (command === "exportExcel") {
        this.handleExportExcel();
      }
      if (command === "synchronize") {
        this.syncTransactionHistory();
      }
    },

    async syncTransactionHistory() {
      this.$notify.info({
        title: "Thông báo",
        message: "Dữ liệu đang được xử lý!"
      });
      const today = new Date();
      const date = today.toISOString().split("T")[0];
      try {
        const res = await sePayConnectionService.syncTransactionHistory(date);
        if (res.data.data === true) {
          this.$notify.success({
            title: "Thông báo",
            message: "Đồng bộ lịch sử thành công"
          });
          this.findAllData(this.activeTabName);
        }
      } catch (err) {
        console.error(err);
      }
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (this.activeTabName === "school") {
          if (index === 17) {
            sums[index] = "Tổng cộng";
            return;
          }
          if (index === 18) {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values
                .reduce((prev, curr) => {
                  const value = Number(curr);
                  return !isNaN(value) ? prev + value : prev;
                }, 0)
                .toLocaleString("vi-VN", {
                  style: "currency",
                  currency: "VND"
                });
            } else {
              sums[index] = "";
            }
          } else {
            sums[index] = "";
          }
        } else {
          if (index === 16) {
            sums[index] = "Tổng cộng";
            return;
          }
          if (index === 17) {
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values
                .reduce((prev, curr) => {
                  const value = Number(curr);
                  return !isNaN(value) ? prev + value : prev;
                }, 0)
                .toLocaleString("vi-VN", {
                  style: "currency",
                  currency: "VND"
                });
            } else {
              sums[index] = "";
            }
          } else {
            sums[index] = "";
          }
        }
      });
      return sums;
    },

    handleSizeChange(value) {
      this.dataFilter.limit = value;
      this.dataFilter.page = 1;
      this.findAllData(this.activeTabName);
    },

    handleCurrentPageChange(value) {
      this.dataFilter.page = value;
      this.findAllData(this.activeTabName);
    },

    calculateStt(index) {
      return (this.dataFilter.page - 1) * this.dataFilter.limit + index + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }

  .gradient-btn {
    border: none;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }

    &.green-btn {
      background: linear-gradient(90deg, #10b981 0%, #059669 100%);
      box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4); }
    }

    &.purple-btn {
      background: linear-gradient(90deg, #8b5cf6 0%, #6d28d9 100%);
      box-shadow: 0 4px 10px rgba(139, 92, 246, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(139, 92, 246, 0.4); }
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.table-container {
  background: #fff;
  padding: 12px;
}

/* Filter Forms */
.modern-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  .modern-date-picker {
    width: 250px;
  }

  .modern-select {
    width: 175px;

    &.school-select {
      width: 250px;
    }
  }

  .modern-input {
    width: 220px;
  }
}

/* Tabs customization */
.modern-tabs {
  /deep/ .el-tabs__header {
    border-bottom: 2px solid #e2e8f0;
    margin-bottom: 16px;
  }
  
  /deep/ .el-tabs__nav {
    border: none !important;
    background: transparent !important;
  }

  /deep/ .el-tabs__item {
    border: none !important;
    font-weight: 600;
    color: #64748b !important;
    border-radius: 6px 6px 0 0;
    transition: all 0.3s;
    
    &.is-active {
      color: #3b82f6 !important;
      background: #eff6ff !important;
      border-bottom: 2px solid #3b82f6 !important;
    }
  }
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 10px 0;
  }

  /deep/ .el-table__footer-wrapper tbody td.el-table__cell,
  /deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
    font-weight: bold;
    background-color: #f8fafc;
    color: #1d4ed8;
  }
}

.student-name {
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
}

.account-num-text {
  font-family: Consolas, Monaco, monospace;
  font-weight: 700;
  color: #475569;
}

.code-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  color: #64748b;
  border: 1px solid #cbd5e1;

  &.success {
    background-color: #f0fdf4;
    border-color: #bbf7d0;
    color: #166534;
  }
}

.date-time-text {
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.amount-text {
  font-family: Consolas, Monaco, monospace;
  font-size: 14px;
  font-weight: 700;

  &.credit {
    color: #166534;
  }

  &.debit {
    color: #991b1b;
  }
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.flex { display: flex; }
.gap-2 { gap: 8px; }
.justify-center { justify-content: center; }
</style>